import Doctors from "./partials/Doctor";
import "./DoctorsList.css";
import Search from "../include/Search";
import { useState } from "react";

const DoctorsList = () => {
  const [search, setSearch] = useState("");

  return (
    <div className="doctors-list-section">
      <Search onSearch={(value) => setSearch(value)} />
      <Doctors search={search} />
    </div>
  );
};

export default DoctorsList;
